<div class="wrapper">
  <div class="container-fluid">
    <nuctrac-header (headerHidden)="setHeaderStatus($event)"></nuctrac-header>
  </div>
  <div
    class="contents dynamic-cont"
    [ngClass]="{ 'mt-33': hideHeader, 'mt-expand-header': !hideHeader }"
  >
    <div class="container-fluid g-0">
      <div class="row">
        <div ui-view="navbar">
          <div>
            <nuctrac-navigation></nuctrac-navigation>
          </div>
        </div>
        <div ui-view="content" class="menu-content">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
</div>
